import PropTypes from "prop-types";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link } from "react-router-dom";
import { usePartner } from "../../helpers/BrandPageAPI";

const BreadcrumbWrap = ({ pages }) => {
  const { partnerData } = usePartner();
  const navColor = partnerData?.StoreColor || "#d4af37";
  return (
    <div className="breadcrumb-area pt-35" style={{ "--navColor": navColor }} >
      <div className="container">
        <Breadcrumb>
          {pages?.map(({ path, label }, i) =>
            i !== pages.length - 1 ? (
              <Breadcrumb.Item
                key={label}
                linkProps={{ to: path }}
                linkAs={Link}
                className="custom-breadcrumb-link"
              >
                {label}
              </Breadcrumb.Item>
            ) : (
              <Breadcrumb.Item key={label} active>
                {label}
              </Breadcrumb.Item>
            )
          )}
        </Breadcrumb>
      </div>
    </div>
  );
};

BreadcrumbWrap.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
};

export default BreadcrumbWrap;
